module.exports = __webpack_public_path__ + "img/product-7-INTzhuanye.efdc0362.png";